
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import {Link} from 'contentbricks'
import { M, I } from './_elements.tsx'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Ja. `}<M mdxType="M">{`Schichtarbeiter und Menschen mit chronischem Schlaf­mangel haben ein erhöhtes Risiko, dick zu werden, eine Adipositas oder einen Typ-2-Diabetes zu entwickeln.`}</M>{` Auch eine Diät zeigt weniger Erfolg, wenn zu wenig geschlafen wird.`}<br /><br />{`
Die Ärztin Eve Van Cauter von der University of Chicago hat in den letzten dreissig Jahren die Verbindung zwischen  `}<Link href='https://www.ncbi.nlm.nih.gov/pmc/articles/PMC4444051/' mdxType="Link">{`Schlaf und Appetit`}</Link>{`  erforscht. Für eine Studienreihe, die auf fünf Tage angelegt war, wurden gesunde, schlanke Probanden in zwei Gruppen eingeteilt. Die eine Gruppe durfte achteinhalb Stunden schlafen, während sich die zweite Gruppe mit vier bis fünf Stunden begnügen musste. Beide Gruppen bekamen das Gleiche zu essen und betätigten sich körperlich im gleichen Masse. Bei allen Probanden wurden täglich die beiden Hormone Leptin und Ghrelin gemessen. Ersteres sorgt für die Sättigung im Körper, während Ghrelin unseren Hunger auslöst. Bei den Probanden, die zu wenig geschlafen hatten, sank die Konzentration des Sättigungshormons Leptin, während das den Hunger auslösende Hormon Ghrelin anstieg. Fazit: Je weniger wir schlafen, desto hungriger werden wir. Ein übermüdeter Mensch isst also tendenziell mehr, als ihm guttun würde – was sich auch in seinem Gewicht zeigen kann.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;